export default ({ request }) => ({

  scheduleListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/info/schedule/list',
      method: 'post',
      data
    })
  },
  scheduleDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/project/info/schedule/detail',
      method: 'post',
      data
    })
  },
  scheduleSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/project/info/schedule/save',
      method: 'post',
      data
    })
  },
  scheduleDelApi (data = {}) {
    return request({
      url: '/digitalCenter/project/info/schedule/del',
      method: 'post',
      data
    })
  },
  scheduleConfirmApi (data = {}) {
    return request({
      url: '/digitalCenter/project/info/schedule/confirm',
      method: 'post',
      data
    })
  }
})
